<template>
  <div class="company-form">
    <h3 v-translate>Company Profile</h3>
    <h4 class="mt-4" v-translate>Basic Info <small class="text-danger">(required)</small></h4>
    <b-row>
      <b-col>
        <form @submit.prevent="saveCompany">
          <b-row>
            <b-col lg="7">
              <b-form-group>
                <label for="company-tin" v-translate>TIN</label>
                <input-facade v-if="tinCountry && $appConfig.tinMask[tinCountry]" :mask="$appConfig.tinMask[tinCountry] || ''" :placeholder="$gettext('TIN')" v-model="company.tin" class="form-control" id="company-tin" :disabled="!!company.id" required />
                <b-input v-else id="company-tin" :disabled="!!company.id" :placeholder="$gettext('TIN')" v-model="company.tin" required />
              </b-form-group>
              <b-form-group>
                <label for="company-business-name" v-translate>Fiscal/Legal Name</label>
                <b-input id="company-business-name" :placeholder="$gettext('Fiscal/Legal Name')" v-model="company.business_name" />
              </b-form-group>
              <b-form-group>
                <label for="company-name" v-translate>Brand/Commercial Name</label>
                <b-input id="company-name" :placeholder="$gettext('Brand/Commercial Name')" v-model="company.name" required />
              </b-form-group>
              <b-form-group>
                <label for="company-address" v-translate>Fiscal/Legal Address</label>
                <b-textarea id="company-address" :placeholder="$gettext('Fiscal/Legal Address')" v-model="company.address" />
              </b-form-group>
            </b-col>
            <b-col class="text-center" lg="5">
              <div v-if="company.logo">
                <div class="logo-container mb-1" :style="{backgroundImage: 'url(' + company.logo + ')'}">
                  <b-img v-if="company.logo" style="width:100%; visibility: hidden;" :src="company.logo" blank-color="#777" alt="img" />
                </div>
                <b-button size="sm" v-b-modal.modalUploadImage>
                  <translate>Change</translate>
                </b-button>
                <b-button size="sm" variant="danger" @click.stop="deleteCompanyLogo">
                  <font-awesome-icon icon="trash-alt" size="2x" style="font-size: 16px;vertical-align: middle" />
                </b-button>
              </div>
              <div v-if="!company.logo" class="no-logo-container d-flex text-center">
                <div class="align-self-center w-100">
                  <b-button v-b-modal.modalUploadImage v-translate>Add Logo</b-button>
                </div>
              </div>
            </b-col>
          </b-row>
          <hr class="my-4">
          <b-row>
            <h5 class="col-12" v-translate>Commercial Contact <small class="text-danger">(required)</small></h5>
            <b-col lg="6" xl="4">
              <b-form-group>
                <label for="company-commercial-name" v-translate>Name</label>
                <b-input id="company-commercial-name" :placeholder="$gettext('Name')" v-model="company.contact_name" required />
              </b-form-group>
            </b-col>
            <b-col lg="6" xl="4">
              <b-form-group>
                <label for="company-commercial-phone" v-translate>Phone</label>
                <b-input id="company-commercial-phone" :placeholder="$gettext('Phone')" v-model="company.phone" required />
              </b-form-group>
            </b-col>
            <b-col lg="6" xl="4">
              <b-form-group>
                <label for="company-commercial-email" v-translate>E-mail</label>
                <b-input id="company-commercial-email" :placeholder="$gettext('E-mail')" v-model="company.email" required />
              </b-form-group>
            </b-col>
          </b-row>
          <hr class="my-4">
          <b-row>
            <h5 class="col-12" v-translate>Billing Contact <small class="text-danger">(required)</small></h5>
            <b-col lg="6" xl="4">
              <b-form-group>
                <label for="company-billing-name" v-translate>Name</label>
                <b-input id="company-billing-name" :placeholder="$gettext('Name')" v-model="company.billing_details.name" required />
              </b-form-group>
            </b-col>
            <b-col lg="6" xl="4">
              <b-form-group>
                <label for="company-billing-last-name" v-translate>Last Name</label>
                <b-input id="company-billing-last-name" :placeholder="$gettext('Last Name')" v-model="company.billing_details.last_name" required />
              </b-form-group>
            </b-col>
            <b-col lg="6" xl="4">
              <b-form-group>
                <label for="company-billing-phone" v-translate>Phone</label>
                <b-input id="company-billing-phone" :placeholder="$gettext('Phone')" v-model="company.billing_details.phone" required />
              </b-form-group>
            </b-col>
            <b-col lg="6" xl="4" v-for="(item, index) in company.billing_details.emails" :key="index">
              <b-form-group>
                <label :for="'company-billing-email-' + index" v-translate="{number: index + 1}">E-mail %{number}</label>
                <b-input-group>
                  <b-input type="email" :placeholder="$gettext('E-mail')" :id="'company__billing__email-' + index" v-model="company.billing_details.emails[index]" required />
                  <b-input-group-append>
                    <b-button size="sm" variant="danger" @click="removeBillingDetailsEmail(index)">
                      <strong>✕</strong>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col lg="6" xl="4">
              <form @submit.prevent="addBillingDetailsEmail" v-if="company.billing_details.emails.length < 5">
                <b-form-group>
                  <label :for="'company-billing-email-' + (company.billing_details.emails.length + 1)" v-translate="{number: company.billing_details.emails.length + 1}">E-mail %{number}</label>
                  <b-input-group>
                    <b-input type="email" :placeholder="$gettext('E-mail')" :id="'company-billing-email-' + (company.billing_details.emails.length + 1)" v-model="newBillingDetailsEmail" required @blur="$refs.argh.click()" />
                    <b-input-group-append>
                      <b-button size="sm" ref="argh" variant="success" :disabled="newBillingDetailsEmail === ''" type="submit">
                        <strong>＋</strong>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <b-form-text v-translate>Up to 5 e-mail addresses that will receive our invoices.</b-form-text>
                </b-form-group>
              </form>
            </b-col>
          </b-row>
          <b-form-group class="col-12 form-actions">
            <b-button size="md" :variant="companyHasChanges ? 'secondary' : 'dark'" :disabled="!companyHasChanges || !hasBillingDetailsEmail" type="submit">
              <b-spinner small v-if="updating"></b-spinner>
              <translate>Save Changes</translate>
            </b-button>
          </b-form-group>
        </form>
      </b-col>
    </b-row>
    <b-modal id="modalUploadImage" ref="modalUploadImage" :hide-footer="true">
      <template #modal-title><translate>Add a new logo image</translate></template>
      <template #modal-header-close><img src="@/assets/img/ic_close.svg" alt="×" /></template>
      <profile-picture-uploader @updateProfileImage="updateCompanyLogo" />
    </b-modal>
  </div>
</template>

<script>
import ProfilePictureUploader from '@/components/ProfilePictureUploader'

export default {
  name: 'CompanyForm',
  components: {
    ProfilePictureUploader
  },
  data() {
    return {
      company: {
        logo: null,
        billing_details: {
          emails: []
        }
      },
      companyLogo: null,
      hash: null,
      newBillingDetailsEmail: '',
      updating: false
    }
  },
  props: {
    companyId: {
      type: [Number, String],
      default: null
    }
  },
  computed: {
    companyHasChanges() {
      return JSON.stringify(this.company) !== this.hash && this.hasBillingDetailsEmail
    },
    hasBillingDetailsEmail() {
      return this.company.billing_details.emails.length > 0
    },
    tinCountry() {
      return window.countries.find(x => x.iso_code === (this.company.country_iso_code || window.country)).language.split('_')[1]
    }
  },
  watch: {
    'company.billing_details': {
      handler(val) {
        if (!val) {
          this.company.billing_details = {
            emails: []
          }
        }
      },
      deep: true
    }
  },
  mounted() {
    if (this.companyId) {
      this.getCompany()
    }
  },
  methods: {
    getCompany() {
      if (this.companyId || this.company.id) {
        const params = {
          includes: [
            'applications'
          ]
        }
        this.$http.get(this.$appConfig.api.baseUrl + 'companies/' + this.companyId || this.company.id, { params })
          .then(response => {
            this.company = response.body
            if (this.company.applications.length === 0 || !this.appsCount(this.company.applications)) {
              this.createDefaultApplication()
            }
            this.hash = JSON.stringify({ ...this.company })
            this.updating = false
          })
      }
    },
    appsCount(items) {
      return items.findIndex(x => x.platform_id === null) !== -1
    },
    addBillingDetailsEmail() {
      this.company.billing_details.emails.push(this.newBillingDetailsEmail)
      this.newBillingDetailsEmail = ''
    },
    removeBillingDetailsEmail(index) {
      this.company.billing_details.emails.splice(index, 1)
    },
    saveCompany() {
      if (!this.company.id) {
        this.createCompany()
      } else {
        this.updateCompany()
      }
    },
    createCompany() {
      this.updating = true
      this.company.country_iso_code = this.profile.company ? this.profile.company.country_iso_code : this.profile.country_iso_code
      if (!this.company.logo) {
        delete this.company.logo
      }
      this.$http.post(this.$appConfig.api.baseUrl + 'companies', this.company)
        .then(response => {
          this.company = response.body
          if (this.companyLogo) {
            this.updateCompanyLogo(this.companyLogo)
          }
          this.createDefaultApplication()
            .then(response => {
              this.$router.push({ name: 'CompaniesEdit', params: { id: response.body.company_id } })
            })
        }, () => {
          this.showUpdateFailure()
        })
    },
    async createDefaultApplication() {
      const params = {
        name: this.company.name,
        company_id: this.company.id,
        active: true
      }
      return await this.$http.post(this.$appConfig.api.baseUrl + 'applications', params)
        .then(response => {
          return response
        })
    },
    updateCompany() {
      this.updating = true
      delete this.company.tin
      delete this.company.country_iso_code
      delete this.company.cut_time_week
      delete this.company.cut_time_saturday
      delete this.company.cut_time_sunday

      this.$http.patch(this.$appConfig.api.baseUrl + 'companies/' + this.company.id, this.company)
        .then(response => {
          this.$refs.modalUploadImage.hide()
          this.showUpdateSuccess()
          this.getCompany()
        }, () => {
          this.showUpdateFailure()
        })
    },
    updateCompanyLogo(url) {
      if (this.company.id) {
        this.company.logo = url
        this.$http.patch(this.$appConfig.api.baseUrl + 'companies/' + this.company.id, { logo: url })
          .then(response => {
            this.$refs.modalUploadImage.hide()
            this.showUpdateSuccess()
            this.getCompany()
          })
      } else {
        this.companyLogo = url
        this.company.logo = this.companyLogo
        this.$refs.modalUploadImage.hide()
      }
    },
    deleteCompanyLogo() {
      if (confirm(this.$gettext('Are you sure you want to DELETE the company\'s logo?'))) {
        this.updateCompanyLogo(null)
      }
    },
    showUpdateSuccess() {
      this.makeToast(this.$gettext('Success'), this.$gettext('The Company has been updated! 👍'), 'success', false, 4000)
    },
    showUpdateFailure() {
      this.makeToast(this.$gettext('ERROR'), this.$gettext('The Company couldn\'t be updated! 👎'), 'danger', false, 4000)
    }
  }
}
</script>

<style lang="scss">
.logo-container,
.no-logo-container {
  height: 100%;
  max-height: 200px;
  background: transparent no-repeat 50% 0;
  background-size: contain;
}
</style>
